import { useState } from "react";

import { NavLink } from "react-router-dom";

import { CustomInput } from "../../kits/inputs/Input.tsx";
import CustomButton from "../../kits/custom-button/CustomButton.tsx";
import { ArrowRightIcon } from "../../kits/Icons/Icons.tsx";
import colorSchema from "../../../assets/kits/colors";
import UploadImage from "../uploadImage/UploadImage.jsx";
import gv from "../../../assets/kits/global-variables.module.scss";
import useWindowSize from "../../../hooks/useWindowSize.jsx";
export default function ManagerInfo() {
  const winSize = useWindowSize();
  const [manager, setManager] = useState({
    identityCardImage: "",
    businessLicenceImage: ""
  });
  function productImageHandler(names, value) {
    setManager(prev => {
      return {
        ...prev,
        [names]: value
      };
    });
  }
  return (
    <div className="">
      <div className="d-flex pd-y-12 pd-x-20 ">
        <NavLink to="/vendor-panel/manager-profile">
          <ArrowRightIcon color={colorSchema.gray_900} />
        </NavLink>

        <h6
          className="title-h3-b mr-r-8"
          style={{ color: colorSchema.gray_900 }}
        >
          اطلاعات مدیر
        </h6>
      </div>

      <div className="pd-x-16">
        <div className="mr-t-12">
          <CustomInput
            title="نام مدیر"
            placeholder="محمد طاشی"
            labelClassName="txt-t2-l pd-b-6"
          />
        </div>
        <div className="mr-t-24">
          <CustomInput
            title="شماره موبایل"
            placeholder="09382573820"
            labelClassName="txt-t2-l pd-b-6"
          />
        </div>
        <div className="mr-t-24">
          <CustomInput
            title="کد ملی"
            placeholder="2122122123"
            labelClassName="txt-t2-l pd-b-6"
          />
        </div>
        <div className="mr-t-24">
          <h6
            className="txt-t2-l mr-b-12"
            style={{ color: colorSchema.gray_900 }}
          >
            کارت ملی
          </h6>
          {manager.identityCardImage == "" ? (
            <UploadImage
              type="empty"
              name="identityCardImage"
              setShopInfo={setManager}
              productImageHandler={productImageHandler}
            />
          ) : (
            <UploadImage
              type="full"
              name="identityCardImage"
              setShopInfo={setManager}
              src={URL.createObjectURL(manager.identityCardImage)}
            />
          )}
        </div>
        <div className="mr-t-24">
          <h6
            className="txt-t2-l mr-b-12"
            style={{ color: colorSchema.gray_900 }}
          >
            جواز کسب و کار
          </h6>
          {manager.businessLicenceImage == "" ? (
            <UploadImage
              type="empty"
              name="businessLicenceImage"
              setShopInfo={setManager}
              productImageHandler={productImageHandler}
            />
          ) : (
            <UploadImage
              type="full"
              name="businessLicenceImage"
              setShopInfo={setManager}
              src={URL.createObjectURL(manager.businessLicenceImage)}
            />
          )}
        </div>
        <div
          className="d-flex justify-content-center"
          style={{
            position: "fixed",
            bottom: "16px",
            maxWidth: "600px",

            left:
              winSize.width > 600
                ? (winSize.width - gv.max_width_var) / 2 + 16
                : 16,
            right:
              winSize.width > 600
                ? (winSize.width - gv.max_width_var) / 2 + 16
                : 16
          }}
        >
          <CustomButton className="w-100">ثبت</CustomButton>
        </div>
      </div>
    </div>
  );
}
